import { graphql, useStaticQuery } from "gatsby";

export const useNavAndFooter = () => {
  try {
    const data = useStaticQuery(graphql`
      query {
        allSanityNav {
          nodes {
            image {
              image {
                asset {
                  gatsbyImageData(placeholder: BLURRED)
                }
              }
              alt
              href
            }
            category {
              name
              link
            }
          }
        }
        allSanityFooter {
          nodes {
            copyright
            footeritems {
              name
              link
            }
            socialmedia {
              Icon {
                asset {
                  gatsbyImageData(placeholder: BLURRED)
                }
              }
              alt
              Link
            }
          }
        }
      }
    `);
    return data;
  } catch (error) {
    console.error(error);
    return {
      allSanityNav: { nodes: [] },
      allSanityFooter: { nodes: [] },
    };
  }
};
